/**
 * Member detail (CT-5611). Tabs, default tab and the product switches of the screen live here so
 * no component carries them as a literal.
 */

/** Internal tabs of the member detail, in display order. `id` is also the route segment. */
export const MEMBER_DETAIL_TABS = Object.freeze([
  { id: 'studios', labelKey: 'memberDetail.tabs.studios' },
  { id: 'roles', labelKey: 'memberDetail.tabs.roles' },
  { id: 'groups', labelKey: 'memberDetail.tabs.groups' },
  { id: 'resources', labelKey: 'memberDetail.tabs.resources' },
  { id: 'security', labelKey: 'memberDetail.tabs.security' },
]);

export const DEFAULT_TAB = 'studios';

/** Department shows in the member card. CT-5611 / CT-5832: the card has no DEPARTMENT (nor role). */
export const SHOW_DEPARTMENT_FIELD = false;

/** Lifetime of a password-reset link, shown in the confirmation toast. */
export const RESET_PASSWORD_EXPIRY_HOURS = 1;

/** Days an invitation stays valid after it is (re)sent. */
export const INVITATION_VALID_DAYS = 7;
